import { CaponePortal } from "@capone/portal";

export default CaponePortal;
